/*******************************************************************************
 * Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>
 *
 * This file BasketTickets.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * BasketTickets.js can not be copied and/or distributed
 * without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
 ******************************************************************************/

export default {
    created(){},
    data(){
        return {}
    },
    methods:{
        /**
         * @see Any calculations here must be reflected on the SessionBasket.php soldOut method
         * @param ticket
         * @returns {boolean}
         */
        isSoldOut: function (ticket) {

            if(ticket.reserved_tickets_count >= ticket.allocated ){
                return true;
            }

            return ticket.sale_content_counter_count > 0 && ticket.sale_content_counter_count >= ticket.allocated ;
        },
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/basket/BasketTickets.js